import { get, post } from '@/utils/http.js'

//获取角色列表
export const getUserList = (data) => post('/user/usemanage',data);

//新增角色
export const addUser = (data) => post('/tr_api/v1/power/add-user',data);

//修改角色
export const editUser = (data) => post('/tr_api/v1/power/update-user',data);

//查看角色详情
export const getUser = (id) => get('/tr_api/v1/power/detail-user/'+id);